export default "__VITE_ASSET__DMQ9p9kF__"